<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{ $t('extracurriculares.pay_reserve.terms_conditions') }}</span>
    </v-card-title>
    <v-card-text>
      <object :data="`${appUrl}/${url}`" width="100%" height="600px"></object>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" flat="flat" @click="$emit('closeTerms')">Cerrar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'terms-conditions-view',
    data() {
      return {
        url: 'storage/extracurriculares/terms.pdf',
        appUrl: window.config.appUrl
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/enrollment/terms.vue